// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bhI8","content":"styles_content__PtFd-"};